export var ShaderType;
(function (ShaderType) {
    ShaderType[ShaderType["Vertex"] = 0] = "Vertex";
    ShaderType[ShaderType["Fragment"] = 1] = "Fragment";
})(ShaderType || (ShaderType = {}));
;
export function compileShader(gl, type, source, version, definitions) {
    var shader;
    switch (type) {
        case ShaderType.Vertex: {
            shader = gl.createShader(gl.VERTEX_SHADER);
            break;
        }
        case ShaderType.Fragment: {
            shader = gl.createShader(gl.FRAGMENT_SHADER);
            break;
        }
        default: {
            return null;
        }
    }
    var definition = definitions.reduce(function (acc, next) {
        return acc + next + "\n";
    }, "");
    var full_source = version + "\n" + definition + source;
    gl.shaderSource(shader, full_source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        var shader_type = (type == 0) ? "Vertex" : "Fragment";
        console.log(shader_type + ", name: " + full_source + ", shader compilation error: " + gl.getShaderInfoLog(shader));
        return null;
    }
    return shader;
}
;
//# sourceMappingURL=shader-source.js.map